var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[(_vm.isAuthenticated)?_c('mc-meal-wizard',{attrs:{"formTitle":"","formSubtitle":""},on:{"savedValue":_vm.saved,"affirmedValue":_vm.affirmed,"mealCountCalc":_vm.countCheck,"isDirty":_vm.isDirty}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }